module.exports = __webpack_public_path__ + "img/Airbnb-Landing-page-working-from-home-.052102ad.jpg";